import { createSelector } from 'reselect';

import { getSelectedGroupId } from 'modules/groups/selectors';
import { isGroupManagement } from 'modules/router/selectors';
import { getSelectedDealerGroupId, getSelectedDealerId } from 'selectors/dealerSelectors';
import { getRoot, getProps } from 'utils/selectors';

import { getScreensaverByIds, getUIState } from './core';

const getState = createSelector(getUIState, state => state.dashboard);

const getDataState = createSelector(getState, state => state.data);

const getLoadingState = createSelector(getState, state => state.loading);

export const getScreensaverIds = createSelector(getDataState, state => state.ids);

export const getError = createSelector(getDataState, state => state.error);

export const getPage = createSelector(getDataState, state => state.page);

export const hasMore = createSelector(getDataState, state => state.hasMore);

export const isLoading = createSelector(getDataState, state => state.loading);

export const getFilters = createSelector(getState, state => state.filters);

export const getDashboardEntries = createSelector(getRoot, getScreensaverIds, getScreensaverByIds);

export const getAdditionalFilters = createSelector(
  isGroupManagement,
  getSelectedGroupId,
  getSelectedDealerId,
  getSelectedDealerGroupId,
  (scopedToGroup, groupId, dealerId, dealerGroupId) =>
    (scopedToGroup ? { groupId, notExist: 'dealerId' } : { groupId: dealerGroupId, dealerId })
);

export const getFormattedFilters = createSelector(
  getFilters,
  getAdditionalFilters,
  getPage,
  (filters, additionalFilters, { size = 10 }) => ({
    ...additionalFilters,
    ...filters,
    size,
    page: 0,
  })
);

export const isCloning = createSelector(getLoadingState, ({ clone }) => clone);

export const isDeleting = createSelector(getLoadingState, getProps, ({ delete: deleteState }, screensaverId) =>
  deleteState.includes(screensaverId));
